import React from "react";
import "./OceShaSection5.css";

// Section 5 images
import salesImg from "../assets/ocesha_images/section5/sales.png";
import checkoutImg from "../assets/ocesha_images/section5/checkout.png";
import learnImg from "../assets/ocesha_images/section5/learn.png";
import earnImg from "../assets/ocesha_images/section5/earn.png";

const steps = [
  {
    icon: "☁",
    label: "Publish",
  },
  {
    icon: "◆",
    label: "Set Your Price",
  },
  {
    icon: "🛒",
    label: "Sell",
  },
  {
    icon: "👥",
    label: "Students Learn",
  },
  {
    icon: "$",
    label: "Earn",
    isLast: true,
  },
];

const panels = [
  {
    img: salesImg,
    alt: "OceSha sales page example",
    title: "Sales Page",
  },
  {
    img: checkoutImg,
    alt: "Stripe checkout example",
    title: "Stripe Checkout",
  },
  {
    img: learnImg,
    alt: "OceSha student learning experience",
    title: "Students Learn",
  },
  {
    img: earnImg,
    alt: "Revenue dashboard example",
    title: "Earn",
  },
];

interface OceShaSection5Props {
  onStartFree?: () => void;
}

const OceShaSection5: React.FC<OceShaSection5Props> = ({
  onStartFree,
}) => {
  return (
    <section
      className="ocsec5-section"
      aria-labelledby="ocsec5-growth-title"
    >
      {/* =====================================================
          MAIN ROUNDED CARD
          ===================================================== */}

      <div className="ocsec5-card">

        <div className="ocsec5-content">

          {/* =================================================
              BADGE
              ================================================= */}

          <div className="ocsec5-badge">
            <span
              className="ocsec5-badge-icon"
              aria-hidden="true"
            >
              ▥
            </span>

            <span>AI-POWERED GROWTH</span>
          </div>


          {/* =================================================
              HEADING
              ================================================= */}

          <h2
            id="ocsec5-growth-title"
            className="ocsec5-h2"
          >
            Turn Your Knowledge
            <br />
            Into a{" "}
            <span className="ocsec5-gradient">
              Business
            </span>
          </h2>


          {/* =================================================
              SUBTITLE
              ================================================= */}

          <div className="ocsec5-subtitle">
            OceSha isn&rsquo;t merely a course generator.
            It&rsquo;s a way to make money from what you know.
          </div>


          {/* =================================================
              BUSINESS FLOW
              ================================================= */}

          <div
            className="ocsec5-steps"
            aria-label="Course business flow"
          >
            {steps.map((step) => (
              <div
                className="ocsec5-step"
                key={step.label}
              >
                <div
                  className={`ocsec5-step-icon${
                    step.isLast
                      ? " ocsec5-step-icon-last"
                      : ""
                  }`}
                  aria-hidden="true"
                >
                  {step.icon}
                </div>

                <div className="ocsec5-step-label">
                  {step.label}
                </div>
              </div>
            ))}
          </div>


          {/* =================================================
              SCREENSHOT PANELS
              ================================================= */}

          <div className="ocsec5-panels">
            {panels.map((panel) => (
              <article
                className="ocsec5-panel"
                key={panel.title}
              >
                <div className="ocsec5-panel-image">
                  <img
                    src={panel.img}
                    alt={panel.alt}
                  />
                </div>

                <h3>{panel.title}</h3>
              </article>
            ))}
          </div>

        </div>
      </div>


      {/* =====================================================
          START FREE BUTTON
          ===================================================== */}

      <div className="ocsec5-action">
        <button
          type="button"
          className="ocsec5-start-button"
          onClick={onStartFree}
        >
          Start Free
        </button>
      </div>

    </section>
  );
};

export default OceShaSection5;